<template>
  <div class="basic-info">
    <h3 class="title-text">团组基本信息</h3>
    <el-form label-width="140px" ref="form" :model="basicInfo" v-loading="isLoad">
      <el-form-item label="团组描述" prop="teamDesc">
        <el-input type="textarea" style="width: 97%" v-model="basicInfo.teamDesc" :readonly="!isCorporation && detail"
          maxlength="500" :autosize="{ minRows: 2 }" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="申报单位" prop="tuxUnit">
        <el-input :readonly="!isCorporation && detail" v-model="basicInfo.tuxUnitName"></el-input>
      </el-form-item>
      <el-form-item label="签发人" prop="signer">
        <el-input :readonly="!isCorporation && detail" v-model="basicInfo.signer"></el-input>
      </el-form-item>
      <el-form-item label="团长姓名" class="is-required">
        <el-row :gutter="10" type="flex">
          <el-col :span="12" style="width: 40%" class="el-col1">
            <el-form-item prop="firstName">
              <el-input style="width:100%" :readonly="!isCorporation && detail" v-model="basicInfo.firstName"
                placeholder="姓"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="width: 59%" class="el-col1">
            <el-form-item prop="lastName">
              <el-input style="width: 100%" :readonly="!isCorporation && detail" v-model="basicInfo.lastName"
                placeholder="名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="团组总人数" prop="teamPerNum">
        <el-input type="number" v-model="basicInfo.teamPerNum" placeholder="如果团组为双跨参团,填写外单位发来的任务批件上的总人数"
          :readonly="!isCorporation && detail"></el-input>
      </el-form-item>
      <el-form-item label="出访国家(地区)" prop="visitCountryCode">
        <el-input :readonly="!isCorporation && detail" v-model="basicInfo.visitCountryName"></el-input>
      </el-form-item>
      <el-form-item label="启程地点" prop="outPlace">
        <el-input :readonly="!isCorporation && detail" v-model="basicInfo.outPlace"></el-input>
      </el-form-item>
      <el-form-item label="出国(境)日期" prop="preDepaDate">
        <foreign-date-picker v-model="basicInfo.preDepaDate" value-format="yyyy-MM-dd"
          :readonly="!isCorporation && detail"></foreign-date-picker>
      </el-form-item>
      <el-form-item label="在外天数" prop="outsideNum">
        <el-input type="number" v-model="basicInfo.outsideNum" :readonly="!isCorporation && detail"></el-input>
      </el-form-item>
      <el-form-item label="回国(境)日期" required>
        <span>{{ backDate }}</span>
      </el-form-item>
      <el-form-item label="出访目的" prop="visitPurpose">
        <base-select v-model="basicInfo.visitPurpose" :clearable="true" :disabled="!isCorporation && detail"
          value-key="dictId" label-key="dictName" dict-type-code="PURPOSE_OF_THE_VISIT"></base-select>
      </el-form-item>
      <el-form-item label="费用来源" prop="costSource">
        <base-select dict-type-code="COST_SOURCE" v-model="basicInfo.costSource" :clearable="true"
          :disabled="!isCorporation && detail" value-key="dictId" label-key="dictName"></base-select>
      </el-form-item>
      <el-form-item label="任务类别" prop="taskType">
        <base-select v-model="basicInfo.taskType" :clearable="true" :disabled="!isCorporation && detail" filterable
          value-key="dictId" label-key="dictName" dict-type-code="TASK_TYPE"></base-select>
      </el-form-item>
      <el-form-item label="费用补充说明">
        <el-input type="textarea" v-model="basicInfo.costAdded" :readonly="!isCorporation && detail"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="basicInfo.remarks" :readonly="!isCorporation && detail"
          :autosize="{ minRows: 2 }" maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="是否办理APEC卡">
        <el-radio label="Y" :disabled="detail" v-model="basicInfo.apecCard">是</el-radio>
        <el-radio label="N" :disabled="detail" v-model="basicInfo.apecCard">否</el-radio>
      </el-form-item>
      <el-form-item label="是否计划内出访">
        <el-radio label="Y" :disabled="detail" v-model="basicInfo.ifVisitPlan">是</el-radio>
        <el-radio label="N" :disabled="detail" v-model="basicInfo.ifVisitPlan">否</el-radio>
      </el-form-item>

      <h3 class="title-text">双跨信息</h3>
      <el-row>
        <el-col :span="24">
          <el-form-item label="是否双跨" prop="twoSpan">
            <span v-if="!isCorporation">{{ basicInfo.twoSpan === 'Y' ? '是' : '否' }}</span>
            <template v-else>
              <el-radio label="Y" v-model="basicInfo.twoSpan" :disabled="!isCorporation && detail">是</el-radio>
              <el-radio label="N" v-model="basicInfo.twoSpan" :disabled="!isCorporation && detail">否</el-radio>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="basicInfo.twoSpan === `Y`">
          <el-form-item label="成团情况" prop="joinGroup">
            <el-radio label="Y" v-model="basicInfo.joinGroup" :disabled="!isCorporation && detail">参团</el-radio>
            <el-radio label="N" v-model="basicInfo.joinGroup" :disabled="!isCorporation && detail">组团</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="basicInfo.twoSpan == 'Y' && basicInfo.joinGroup === `Y`">
          <el-form-item label="组团单位任务批件文号">
            <el-input v-model="basicInfo.tuxTaskBatchNo" :clearable="true"
              :readonly="!isCorporation && detail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="basicInfo.twoSpan === `Y`">
          <el-form-item :label="getTitle()" prop="outTuxUnit">
            <el-input v-if="basicInfo.joinGroup == 'Y'" v-model="basicInfo.outTuxUnit"
              :readonly="!isCorporation && detail"></el-input>
            <edit-unit v-else :outTuxUnitList="basicInfo.outTuxUnitList" :readonly="!isCorporation && detail"
              @save="changeOutTuxUnit"></edit-unit>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="basicInfo.twoSpan == 'Y'">
          <el-form-item label="我方人数" prop="ourPerNum">
            <el-input v-model="basicInfo.ourPerNum" type="number" :readonly="!isCorporation && detail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="basicInfo.twoSpan == 'Y'">
          <el-form-item label="对方人数" v-if="basicInfo.joinGroup === `N`" prop="outPerNum">
            <el-input v-model="basicInfo.outPerNum" type="number" :clearable="true"
              :readonly="!isCorporation && detail"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <h3 class="title-text">出访路线</h3>
    <el-table border :data="routeList" :header-cell-style="{ 'text-align': 'left' }">
      <el-table-column label="序号" type="index"></el-table-column>
      <el-table-column prop="visitCountryName" label="出访国家(地区)"></el-table-column>
      <el-table-column prop="entryCity" label="入境城市"></el-table-column>
      <el-table-column prop="depaCity" label="出境城市"></el-table-column>
      <el-table-column prop="entryDateString" label="入境日期"></el-table-column>
      <el-table-column prop="visaValidity" label="签证(注)有效期"></el-table-column>
      <el-table-column prop="inviUnitName" label="邀请单位">
        <template slot-scope="props">
          <span>{{ props.row.inviUnitName }}{{ props.row.inviUnitNameEn && `(${props.row.inviUnitNameEn})` }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stayDay" label="停留天数"></el-table-column>
      <el-table-column prop="visitReason" label="出访事由"></el-table-column>
    </el-table>
    <h3 class="title-text">出访成员</h3>
    <template v-if="personList.length > 10">
      <el-table :data="cachedPerson" border :header-cell-style="{ 'text-align': 'left' }">
        <el-table-column label="序号" prop="orderNo"></el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="props">
            <span>{{ props.row.firstName + props.row.lastName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="props">
            <div>{{ props.row.sex === "M" ? "男" : "女" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="birthday" label="出生日期"></el-table-column>
        <el-table-column prop="placeBirth" label="出生地"></el-table-column>
        <el-table-column prop="workUnit" label="工作单位"></el-table-column>
        <el-table-column align="center" prop="passportNo" label="证照号">
          <template v-slot="{ row }">
            <span>{{ row.passportNo }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="validityDate" label="证照有效期"></el-table-column>
        <el-table-column prop="extIde" label="对外身份"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="props">
            <el-row type="flex">
              <el-button v-show="props.row.scanningCopy" type="text" @click="viewScanning(props.row)">查看扫描件</el-button>
              <el-button type="text" @click="cardInfo(props.$index)">证照信息</el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :total="personList.length" @current-change="changePerson" :current-page="pageNo" :pageSize="10"
        layout="prev,pager,next"></el-pagination>
    </template>
    <template v-else>
      <el-table :data="personList" border>
        <el-table-column align="center" label="序号" type="index"></el-table-column>
        <el-table-column align="center" label="姓名">
          <template slot-scope="props">
            <span>{{ props.row.firstName + props.row.lastName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="性别">
          <template slot-scope="props">
            <div>{{ props.row.sex === "M" ? "男" : "女" }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="birthday" label="出生日期"></el-table-column>
        <el-table-column align="center" prop="placeBirth" label="出生地"></el-table-column>
        <el-table-column align="center" prop="passportNo" label="证照号">
          <template v-slot="{ row }">
            <span>{{ row.passportNo }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="validityDate" label="证照有效期"></el-table-column>
        <el-table-column align="center" prop="workUnit" label="工作单位"></el-table-column>
        <el-table-column align="center" prop="extIde" label="对外身份"></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="props">
            <el-row>
              <el-button v-show="props.row.scanningCopy" type="text" @click="viewScanning(props.row)">查看扫描件</el-button>
              <el-button type="text" @click="cardInfo(props.$index)">证照信息</el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <h3 class="title-text">流程日志</h3>
    <div style="margin-bottom: 15px; padding: 20px 12px 0px 12px; background-color: #ffffff;">
      <processView :process-id="processId" :inst-id="processInstId" :approvalTag="approvalTag"></processView>
    </div>

    <el-dialog :visible.sync="vis_preview" class="preview-dialog" width="100vw" top="30px" :show-close="true">
      <el-row v-show="passportPage">
        <h3 class="text-title">证照页</h3>
        <img :src="passportPage" alt>
      </el-row>
      <el-row v-show="validPassport">
        <h3 class="text-title">有效证件</h3>
        <img :src="validPassport" style="max-width: 100%" v-print="'max-width: 105mm;max-height:148.5mm'" alt>
      </el-row>
      <el-row v-show="residencePhoto">
        <h3 class="text-title">户口本</h3>
        <img :src="residencePhoto" style="max-width: 100%" alt>
      </el-row>
      <el-row v-show="signature">
        <h3 class="text-title">签名</h3>
        <img :src="signature" style="max-width: 100%" alt>
      </el-row>
      <el-row v-show="imgUrl">
        <img :src="imgUrl" alt>
      </el-row>
      <div v-if="!passportPage && !validPassport && !residencePhoto && !signature && !imgUrl" class="no-data">
        <span>该人员未存有证照扫描件</span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="vis_receiver" :close-on-click-modal="false" :show-close="false">
      <receiver-select :info="basicInfo" @close="vis_receiver = false" @success="successHandler"></receiver-select>
    </el-dialog>
    <print-scan :visible.sync="vis_scan" :scan="currentScan" :mobile="true"></print-scan>
    <person-dialog :visible.sync="vis_person" :person-info-id="currentPerson"></person-dialog>
  </div>
</template>
<script>
import SetupApi, { CorporationApi } from "@/api/setup";
let Api = new SetupApi();
import receiverSelect from "./receiver_select";
import processView from "./process_dialog";
import { mapGetters } from "vuex";
import imgFile from "@/components/img-file";
import BaseSelect from "@/components/foreign-base-select/foreign-base-select";
import personDialog from "./person_info_all";
import printScan from "./print_scan";
import editUnit from "./edit_unit.vue"
export default {
  name: "InfoOverviewMobile",
  components: {
    receiverSelect,
    BaseSelect,
    imgFile,
    printScan,
    personDialog,
    processView,
    editUnit
  },
  computed: {
    approvalTag: function () {
      let status = Number(this.applyStatus);
      if (status === 6 || status === 7) {
        return false
      } else {
        return true
      }
    },
    teamName: function () {
      try {
        if (
          this.basicInfo.visitCountryName &&
          this.basicInfo.taskTypeName &&
          this.basicInfo.firstName &&
          this.basicInfo.lastName
        ) {
          return `赴${this.basicInfo.visitCountryName}执行${this.basicInfo.taskTypeName
            }任务${this.basicInfo.firstName}${this.basicInfo.lastName}${this.basicInfo.ourPerNum > 1 ? "等人" : ""
            }`;
        }
      } catch (e) {
        console.log("name=error", e);
      }
      return "";
    },
    backDate: function () {
      if (this.basicInfo.preDepaDate && this.basicInfo.outsideNum) {
        try {
          let d = new Date(this.basicInfo.preDepaDate);
          let add = d.getTime() + this.basicInfo.outsideNum * 24 * 3600 * 1000;
          let n = new Date(add);
          let today = n.getDate() < 10 ? `0${n.getDate()}` : n.getDate();
          let month = n.getMonth() + 1 < 10 ? `0${n.getMonth() + 1}` : n.getMonth() + 1;
          return `${n.getFullYear()}-${month}-${today}`;
        } catch (e) {
          console.log("error", e);
        }
      }
      return "";
    },
    notApproval: function () {
      return !this.$route.path.match(/approval/);
    },
    ...mapGetters(["token"])
  },
  props: {
    itemInfoId: {
      type: String
    },
    detail: {
      type: Boolean
    },
    isCorporation: {
      type: String | Number
    }
  },
  watch: {
    itemInfoId: function (v) {
      if (v) {
        this.isLoad = true;
        Api.getOverview({ itemInfoId: this.itemInfoId }).then(res => {
          this.applyStatus = res.data.stateItemInfo.applyStatus;
          this.basicInfo = res.data.stateItemInfo;
          if (this.basicInfo.ifVisitPlan == '') {
            this.basicInfo.ifVisitPlan = 'N'
          }
          console.log("this.basicInfo", this.basicInfo);
          res.data.commAnnexList.forEach(a => {
            let target = this.fileList.find(file => {
              return file.type === Number(a.type);
            });
            if (target) {
              target.path = a.path;
              target.fileName = a.fileName;
            }
          });
          this.routeList = res.data.visitInfoList;
          this.personList = res.data.personInfoList.map(a => {
            if (a.passports.length) {
              a.passportNo = a.passports[0].passportNo;
              a.validityDate = a.passports[0].validityDate;
              a.scanningCopy = a.passports[0].scanningCopy;
            }
            return a;
          });
          this.$forceUpdate();
          this.isLoad = false;
        });
      }
    }
  },
  data() {
    return {
      applyStatus: undefined, // 当前数据的审批状态
      basicInfo: {},
      routeList: [],
      fileList: [
        { path: "", fileName: "", type: 1, label: "立项请示" },
        { path: "", fileName: "", type: 2, label: "备案表" },
        { path: "", fileName: "", type: 3, label: "邀请函" },
        { path: "", fileName: "", type: 6, label: "保密承诺书" },
        { path: "", fileName: "", type: 7, label: "回访记录表" },
        { path: "", fileName: "", type: 8, label: "公示情况" },
        { path: "", fileName: "", type: 9, label: "出访报告" },
        { path: "", fileName: "", type: 4, label: "培训证明" },
        { path: "", fileName: "", type: 5, label: "补充附件" },
        { path: "", fileName: "", type: 10, label: "日程安排" },
      ],
      personList: [],
      companyList: [],
      consulateList: [],
      cachedPerson: [],
      pageNo: 1,
      passportPage: null,
      vis_preview: false,
      vis_person: false,
      currentPerson: null,
      validPassport: null,
      residencePhoto: null,
      signature: null,
      imgUrl: null,
      isLoad: false,
      vis_scan: false,
      vis_receiver: false,
      currentScan: "",
      processId: "",
      processInstId: ""
    };
  },
  methods: {
    changePerson(v) {
      this.pageNo = v;
      this.cachedPerson = this.personList.slice((v - 1) * 10, v * 10);
    },
    getTitle() {
      let title = this.basicInfo.joinGroup === "Y" ? "组团单位名称" : "参团单位名称";
      return title;
    },
    //修改了参团单位
    changeOutTuxUnit(outTuxUnitList, outTuxUnit) {
      this.basicInfo.outTuxUnit = outTuxUnit;
      this.basicInfo.outTuxUnitList = outTuxUnitList;
    },
    changeRowPassport(row) {
      row.validityDate = row.passports.find(
        a => a.passportNo === row.passportNo
      ).validityDate;
    },
    viewScanning(row) {
      this.currentScan = row.scanningCopy;
      this.vis_scan = true;
    },
    // 保存基本信息
    saveBasic() {
      let data = Object.assign({}, this.basicInfo);
      data.fileList = this.fileList.filter(a => a.path);
      this.isLoad = true;
      Api.update(data)
        .then(res => {
          this.isLoad = false;
          this.$message(res.msg);
        })
        .catch(e => {
          this.isLoad = false;
        });
    },
    // 返回上一步
    back() {
      this.$emit("prev");
    },
    // 返回列表
    backList() {
      this.$router.go(-1);
    },
    viewAllInfo(row) {
      this.currentPerson = row.personInfoId;
      this.vis_person = true;
    },
    rejectHandler() {
      this.$prompt("请输入退回原因", "提示").then(({ value }) => {
        let Corporation = new CorporationApi();
        Corporation.fallback({
          itemInfoId: this.itemInfoId,
          returnReason: value
        }).then(res => {
          this.$message(res.msg);
          this.backList();
        });
      });
    },
    // 提交审批
    approvalHandler() {
      let id = "";
      this.isLoad = true;
      let Api = new CorporationApi();
      Api.getApplicationId().then(res => {
        id = res.data.id;
        Api.getProcessInfo(id).then(res => {
          let pcUrl = "";
          if (process.env.SSO_HOST === "'https://sca.cncecyc.com") {
            pcUrl = window.origin + "/set_up/setup_approval";
          } else {
            pcUrl = window.origin + "/foreign/set_up/setup_approval";
          }
          let data = {
            itemInfoId: this.basicInfo.itemInfoId,
            backable: false,
            processInstName: this.basicInfo.teamName,
            dynamicParams: {
              dynamicParams: {
                pcUrl: pcUrl
              }
            },
            formModelData: {
              applicationId: id,
              formId: res.data.form.id
            },
            judgeable: false,
            muCompleted: false,
            processId: res.data.process.id
          };
          Api.submitApproval(data)
            .then(res => {
              if (res.code == 1) {
                this.basicInfo.status = "45";
              }
              this.isLoad = false;
              this.$message(res.msg);
            })
            .catch(e => {
              this.isLoad = false;
            });
        });
      });
    },
    goPrint(type) {
      let a = document.createElement("a");
      a.target = "_blank";
      if (type === 6) {
        let { href } = this.$router.resolve({
          path: "/promise_text",
          query: { id: this.info.itemInfoId }
        });
        a.href = href;
      } else {
        let { href } = this.$router.resolve({
          path: "/return_visit_table",
          query: { id: this.info.itemInfoId }
        });
        a.href = href;
      }
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    successHandler() {
      this.$message({
        type: "success",
        message: "提交成功"
      });
      this.vis_receiver = false;
      this.$router.push({ path: "/set_up/company_setup" });
    },
    downloadHandler(index) {
      let url = "";
      url = `/share-foreign/commannex/viewAnnex?path=${this.fileList[index].path
        }&token=${this.token}`;
      let a = document.createElement("a");
      a.href = url;
      a.download = this.fileList[index].fileName;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    previewFile(index) {
      if (this.fileList[index].fileName.match(/\.jpe?g$|\.png$|\.gif$/)) {
        this.imgUrl = `/share-foreign/commannex/viewAnnex?path=${this.fileList[index].path
          }&token=${this.token}`;
        this.vis_preview = true;
      } else if (this.fileList[index].fileName.match(/\.pdf$/)) {
        window.open(
          "/share-foreign/commannex/viewAnnex?path=" +
          this.fileList[index].path +
          "&token=" +
          this.token
        );
      } else {
        this.$message("仅支持jpg、jpeg、png、gif和pdf类型文件的预览");
      }
    },
    cardInfo(index) {
      this.residencePhoto = this.personList[index].residenceBooklet;
      this.validPassport = this.personList[index].validPassportPhoto;
      this.passportPage = this.personList[index].passportPage;
      this.signature = this.personList[index].signature;
      this.vis_preview = true;
    },
    editInfo(index) {
      this.$emit("next", index);
    }
  },
  created() {
    this.processId = this.$route.query.processId;
    this.processInstId = this.$route.query.processInstId;
  },
  mounted() {
    console.log(123, this.itemInfoId);

    if (this.itemInfoId) {
      this.isLoad = true;
      Api.getOverview({ itemInfoId: this.itemInfoId }).then(res => {
        this.applyStatus = res.data.stateItemInfo.applyStatus;
        this.basicInfo = res.data.stateItemInfo;
        if (this.basicInfo.ifVisitPlan == '') {
          this.basicInfo.ifVisitPlan = 'N'
        }
        res.data.commAnnexList.forEach(a => {
          let target = this.fileList.find(file => {
            return file.type === Number(a.type);
          });
          if (target) {
            target.path = a.path;
            target.fileName = a.fileName;
          }
        });
        this.routeList = res.data.visitInfoList;
        this.personList = res.data.personInfoList.map(a => {
          if (a.passports.length) {
            a.passportNo = a.passports[0].passportNo;
            a.validityDate = a.passports[0].validityDate;
            a.scanningCopy = a.passports[0].scanningCopy;
          }
          return a;
        });
        if (this.personList.length > 10) {
          this.cachedPerson = this.personList.slice(0, 10);
        }
        this.isLoad = false;
        this.$forceUpdate();
      });
    }
  }
};
</script>
<style lang="scss">
@import "../style/info.scss";

.preview-dialog {
  .no-data {
    height: 30px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #aaa;
  }
}
</style>
